/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.data.repository.cauce

import kotlinx.coroutines.flow.Flow
import studio.oddpods.cauce.core.model.patient.CreatePatientRequest
import studio.oddpods.cauce.core.model.patient.Patient

interface PatientRepository {
    fun getPatients(activeOnly: Boolean = true): Flow<List<Patient>>
    fun observePatient(patientId: String): Flow<Patient?>
    suspend fun getPatient(patientId: String): Result<Patient>
    suspend fun createPatient(request: CreatePatientRequest): Result<Patient>
    suspend fun updatePatient(patientId: String, request: CreatePatientRequest): Result<Patient>
    suspend fun deactivatePatient(patientId: String): Result<Unit>
}
